import { Typography } from 'antd';
import { FC, memo } from 'react';

export const EmptyText: FC = memo(() => {
  return (
    <Typography.Text italic type="secondary">
      (пусто)
    </Typography.Text>
  );
});
